export const styleSheet = () => ({
  subHeaderSectionOuter: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    backgroundColor: "#F0F0F0",
    height: "70px",
    marginBottom: "50px",
  },
  subHeaderSection: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "10px 0px",
    height: "70px",
    "& .MuiTypography-root": {
      fontSize: "12px !important",
    },
  },
  buttonItem: {
    width: "70px",
    height: "70px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#E5E5E5",
    },
  },
  buttonItem1: {
    width: "70px",
    height: "70px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#E5E5E5",
    },
  },
  buttonIcon: {
    width: "28px",
    height: "28px",
  },
  buttonText: {
    fontSize: "12px !important",
    fontWeight: "500",
    marginTop: "0px !important",
  },
  selectBox: {
    width: "146px",
    backgroundColor: "white !important",
    marginLeft: "10px !important",
    marginRight: "20px !important",
  },
  subHeaderSectionRight: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "0px",
  },
});
